module.exports = __webpack_public_path__ + "static/media/art-clip7.caa95944.png";